import React, { useEffect, useState } from "react";
import { ChangeTitle, dateFormat, toAbsoluteUrl } from "../../helpers/Reusable";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { useLocation } from "react-router-dom";

const QueriesDetails = () => {
  ChangeTitle("Queries Details");
  const [queriesDetails, setQueriesDetails] = useState();
  const [queriesDetailsEmptyMsg, setQueriesDetailsEmptyMsg] = useState("");
  const location = useLocation();
  const { aid, queriesId } = location.state || {};

  // Query List API Call
  const viewQueriesDetailsList = async (aid, id) => {
    const param = {
      queriesId: id,
    };
    var response = await postData(
      "private/queries/question/answer",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data[0];
      console.log("answerLength", Object.keys(data.answerDetail).length === 0);

      const message = response.data.message;
      if (data.length === 0) {
        setQueriesDetailsEmptyMsg(message);
      } else {
        setQueriesDetailsEmptyMsg("");
      }
      setQueriesDetails(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewQueriesDetailsList(aid, queriesId);
  }, [aid, queriesId]);

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="w-full mb-[5%] md:mb-[2%]">
          <h1 className="hanson text-center mb-[1%] heading">Queries</h1>
          <img
            className="mb-[2%] mx-auto"
            src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
            alt=""
          />
        </div>
        {queriesDetails && (
          <div className="w-full lg:w-[90%] xl:w-[80%] p-[5%] sm:p-[2%] mx-auto sec-queries-box sec-queries-details">
            <h1 className="sqd-main-title">{queriesDetails.question}</h1>
            <h2 className="mb-10 sqd-title-date">
              (Published date:{" "}
              {queriesDetails.createdDate &&
                dateFormat(queriesDetails.createdDate)}
              )
            </h2>
            <div className="w-full flex flex-col gap-10 justify-center">
              <div className="w-full p-[5%] sm:p-[2%] flex flex-col md:flex-row gap-10 md:gap-5 lg:gap-10 h-full cursor-pointer sqb-box">
                <div className="w-full flex flex-col sm:flex-row gap-5 lg:gap-10">
                  <div className="w-[15vw] h-[15vw] lg:w-[7vw] lg:h-[7vw]">
                    <img
                      className="w-full h-full"
                      src={
                        queriesDetails.userDetail &&
                        queriesDetails.userDetail.profile
                      }
                      alt="justice Image"
                    />
                  </div>
                  <div className="sm:w-[85%]">
                    <div className="pb-[2%] mb-[2%] sqb-box-p1 sqd-box-p1">
                      <h1 className="sqdb-heading">
                        Question added{" "}
                        <span>
                          {queriesDetails.postedDate &&
                            queriesDetails.postedDate}
                        </span>{" "}
                        misc{" "}
                        <span>
                          by{" "}
                          {queriesDetails.userDetail.fullName &&
                            queriesDetails.userDetail.fullName}
                        </span>
                      </h1>
                    </div>
                    <div className="w-full sqd-box-p2">
                      <div className="mb-[3%]">
                        <h1 className="sqdbp2-title">
                          Q. {queriesDetails && queriesDetails.question}
                        </h1>
                        <h2 className="ml-[2%] sqdbp2-date">
                          (Published date:{" "}
                          {queriesDetails.createdDate &&
                            dateFormat(queriesDetails.createdDate)}
                          )
                        </h2>
                      </div>
                      <p className="sqdbp2-para">
                        {queriesDetails && queriesDetails.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {Object.keys(queriesDetails.answerDetail).length != 0 && (
                <div className="w-full p-[5%] sm:p-[2%] flex flex-col md:flex-row gap-10 md:gap-5 lg:gap-10 h-full cursor-pointer sqb-box sqdab-box">
                  <div className="w-full">
                    <h1 className="mb-[2%] sqdab-heading">1. Answer</h1>
                    <div className="w-full flex flex-col sm:flex-row gap-5 lg:gap-10">
                      <div className="w-[15vw] h-[15vw] lg:w-[7vw] lg:h-[7vw]">
                        <img
                          className="w-full h-full"
                          src={
                            queriesDetails.answerDetail &&
                            queriesDetails.answerDetail.answerByImage
                          }
                          alt="justice Image"
                        />
                      </div>
                      <div className="sm:w-[85%]">
                        <div className="pb-[2%] mb-[2%] sqb-box-p1 sqd-box-p1">
                          <h1 className="sqdb-heading">
                            Answered{" "}
                            <span>
                              {queriesDetails.answerDetail.postDate} By{" "}
                              {queriesDetails.answerDetail.answerBy}
                            </span>
                          </h1>
                        </div>
                        <div className="w-full sqd-box-p2">
                          <p className="mb-[2%] sqdbp2-para" dangerouslySetInnerHTML={{ __html: queriesDetails.answerDetail.answer }}>
                          </p>
                          {/* <div className="w-full flex items-center gap-3">
                            <img
                              className="sm:w-[3rem]"
                              src={toAbsoluteUrl(
                                "media/img/icon/basic/messages-3.svg"
                              )}
                              alt=""
                            />
                            <h1 className="sqdbp2-comment">Comment</h1>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default QueriesDetails;
